// Filename - components/SubMenu.js

import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Lock as LockIcon } from '@mui/icons-material';
import GuestPromptModal from './GuestPromptModal';

const SidebarLink = styled(Link)`
    display: flex;
    color:black;
    background:#DCE8F7;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    list-style: none;
    height: 40px;
    text-decoration: none;
    font-size: 18px;

    &:hover {
        background: #DCE8F7;
        border-left: 4px solid #275AA6;
        cursor: pointer;
    }
`;

const SidebarLabel = styled.span`
    margin-left: 16px;
`;

const DropdownLink = styled(Link)`
    background-color: ${(props) => props.isSelected ? '#ced6e0' : '#DCE8F7'};
    height: 34px;
    padding-left: 2.4rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: ${(props) => (props.disabled ? '#a0a0a0' : '#275AA6')};
    font-size: 1rem;
    pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
    &:hover {
        background: ${(props) => (props.disabled ? '#e0e0e0' : '#275AA6')};
        color: ${(props) => (props.disabled ? '#a0a0a0' : '#C8D5F5')};
        cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    }
`;

const DropdownButton = styled.div`
    background-color: ${(props) => props.isSelected ? '#ced6e0' : '#DCE8F7'};
    height: 34px;
    padding-left: 2.4rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: ${(props) => (props.disabled ? '#a0a0a0' : (props.restricted ? '#888' : '#275AA6'))};
    font-size: 1rem;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${(props) => props.restricted ? '0.7' : '1'};
    position: relative;
    &:hover {
        background: ${(props) => (props.disabled ? '#e0e0e0' : '#b8c5d9')};
        color: ${(props) => (props.disabled ? '#a0a0a0' : '#275AA6')};
    }
`;

const SubMenu = ({ item, menuRef, selectedIndex, setActiveMetric,activeMetric,activeAirport,setActiveAirport,setAirportSelectedIndex,enabledAirports,handleClick,currentUser}) => {
    const [subnav, setSubnav] = useState(true);
    const [showGuestModal, setShowGuestModal] = useState(false);
    const [selectedFeature, setSelectedFeature] = useState('');
    
    const showSubnav = () => setSubnav(!subnav);
    
    const handleRestrictedClick = (itemTitle, event) => {
        event.preventDefault();
        setSelectedFeature(itemTitle);
        setShowGuestModal(true);
    };
    
    const handleCloseModal = () => {
        setShowGuestModal(false);
        setSelectedFeature('');
    };
    return (
        <>
            <SidebarLink
                to={item.path}
                onClick={item.subNav && showSubnav}
            >
                <div>
                    {item.icon}
                    <SidebarLabel>
                        {item.title}
                    </SidebarLabel>
                </div>
                <div>
                    {item.subNav && subnav
                        ? item.iconOpened
                        : item.subNav
                        ? item.iconClosed
                        : null}
                </div>
            </SidebarLink>
            {subnav &&
                item.subNav.map((item, index) => {
                    const isDisabled = Object.hasOwn(item,'disabled') ? item.disabled : false;
                    const requiresAuth = item.requiresAuth !== false; // Default to true if not specified
                    const isRestricted = !currentUser && requiresAuth;
                    
                    if (isRestricted) {
                        return (
                            <DropdownButton
                                key={index}
                                isSelected={(index === (selectedIndex-menuRef))}
                                disabled={isDisabled}
                                restricted={true}
                                onClick={(e) => handleRestrictedClick(item.title, e)}
                            >
                                {item.icon}
                                <SidebarLabel>
                                    {item.title}
                                </SidebarLabel>
                                <LockIcon sx={{ ml: 'auto', mr: 1, fontSize: 16, opacity: 0.6 }} />
                            </DropdownButton>
                        );
                    }
                    
                    // Dynamic path logic for NAS-wide Summary based on auth status
                    const getItemPath = () => {
                        // For NAS-wide Summary, use /guest for guests and / for authenticated users
                        if (item.title === 'NAS-wide Summary') {
                            return currentUser ? '/' : '/guest';
                        }
                        // For other items, use existing logic
                        return (item.ref==='')||(Object.hasOwn(enabledAirports,item.ref)&&(!enabledAirports[item.ref].includes(activeAirport)))?item.path:(item.path+'/'+activeAirport);
                    };
                    
                    return (
                        <DropdownLink
                            to={getItemPath()}
                            key={index}
                            isSelected={(index === (selectedIndex-menuRef))}
                            disabled={isDisabled}
                            onClick={() => {handleClick(menuRef+index);
                                            setActiveMetric(item.ref!==''?item.ref:'');
                                            if(Object.hasOwn(enabledAirports,item.ref)&&(!enabledAirports[item.ref].includes(activeAirport))){
                                                setActiveAirport('')
                                            }
                                            if(item.ref===''){
                                                setActiveAirport('')
                                                setAirportSelectedIndex(null)
                                            }
                            }}
                        >
                            {item.icon}
                            <SidebarLabel>
                                {item.title}
                            </SidebarLabel>
                        </DropdownLink>
                    );
                })}
            
            <GuestPromptModal 
                open={showGuestModal} 
                onClose={handleCloseModal} 
                featureName={selectedFeature}
            />
        </>
    );
};

export default SubMenu;
